import { datadogRum } from '@datadog/browser-rum';

type DDUser = {
  id: string;
  email?: string;
  applicantId?: string;
};

const setDDUser = (user: DDUser) => {
  datadogRum.setUser({ ...user });
};

export { setDDUser };
